export default "__VITE_ASSET__1770aea6__"